import React, { createContext, useCallback, useEffect, useMemo, useState } from 'react';
import api from '../config/api';

export const PosDeviceContext = createContext({
  loading: true,
  enrolled: false,
  device: null,
  refresh: async () => {}
});

export function PosDeviceProvider({ children }) {
  const [loading, setLoading] = useState(true);
  const [device, setDevice] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get('/pos-devices/current', {
        headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' }
      });
      if (data.enrolled) {
        setDevice(data.device);
      } else {
        setDevice(null);
        // Do not clear localStorage here — a stale cookie can make /current look
        // unenrolled while the stored secret is still valid after re-enroll.
      }
      return data;
    } catch {
      setDevice(null);
      return { enrolled: false, device: null };
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const value = useMemo(
    () => ({ loading, enrolled: Boolean(device), device, refresh }),
    [loading, device, refresh]
  );

  return <PosDeviceContext.Provider value={value}>{children}</PosDeviceContext.Provider>;
}
